import React, { Component } from 'react'
import Header from '../Header'
import LoginForm from '../LoginForm'
import firebase from '../../modules/Firebase'
import './App.css';

class App extends Component {
  state = {
    loginChecked: false,
    isLoggedIn: false,
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(this.setUserToState)
  }

  setUserToState = (user) => {
    this.setState({
      isLoggedIn: Boolean(user && user.email),
      loginChecked: true,
    })
  }

  render() {
    const { children } = this.props
    const { isLoggedIn, loginChecked } = this.state
    if (!loginChecked) return null
    return (
      <div className="app">
        <Header />
        {!isLoggedIn && <LoginForm />}
        {isLoggedIn && children}
      </div>
    )
  }
}

export default App




// WEBPACK FOOTER //
// ./src/components/App/index.js